import React, { useState, useEffect } from 'react';
import { Modal, Transfer, message, Spin } from 'antd';
import axiosInstance from '../../services/axiosServicesVisit';

const AssignSamplesModal = ({ visible, onCancel, delegate }) => {
    const [targetKeys, setTargetKeys] = useState([]);
    const [allSamples, setAllSamples] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        if (visible && delegate) {
            setLoading(true);
            const fetchSamples = axiosInstance.get('/v1/samples?page=1&limit=1000');
            const fetchDelegateDetails = axiosInstance.get(`/v1/delegates/${delegate.id}`);

            Promise.all([fetchSamples, fetchDelegateDetails])
                .then(([samplesRes, delegateRes]) => {
                    const all = samplesRes.data?.data.map(s => ({ key: s.id, title: s.name })) || [];
                    setAllSamples(all);
                    
                    const assignedIds = delegateRes.data?.samples?.map(s => s.id) || [];
                    setTargetKeys(assignedIds);
                })
                .catch(() => message.error("Erreur de chargement des données."))
                .finally(() => setLoading(false));
        }
    }, [visible, delegate]);

    const handleChange = (newTargetKeys) => {
        setTargetKeys(newTargetKeys);
    };

    const handleOk = async () => {
        setSubmitLoading(true);
        try {
            await axiosInstance.post(`/v1/delegates/${delegate.id}/assign-samples`, {
                sampleIds: targetKeys
            });
            message.success("Assignation des échantillons mise à jour.");
            onCancel();
        } catch (error) {
            message.error("Erreur lors de la mise à jour.");
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <Modal
            title={`Assigner des Échantillons à ${delegate?.firstname} ${delegate?.lastname}`}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={800}
            confirmLoading={submitLoading}
            destroyOnClose
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}><Spin /></div>
            ) : (
                <Transfer
                    dataSource={allSamples}
                    targetKeys={targetKeys}
                    onChange={handleChange}
                    render={item => item.title}
                    listStyle={{ width: 350, height: 400 }}
                    showSearch
                    filterOption={(inputValue, option) => option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1}
                />
            )}
        </Modal>
    );
};

export default AssignSamplesModal;